// Generic cert ceremony confirmation modal.
//
// Wraps the standard <Modal> primitive so every certification ceremony in
// the Underwriting tab uses identical attestation language wording: a
// short title + a longer attestation body the user must read before
// confirming. The actual API call is the caller's responsibility — this
// component is presentation-only.

import { Modal } from "@/components/ui/Modal";
import { Button } from "@/design-system/components/ui";

interface CertConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  /** Attestation language the user reads + agrees to. Free-form text. */
  attestationText: string;
  /** Default "Sign certification". */
  confirmLabel?: string;
  onConfirm: () => void | Promise<void>;
  pending?: boolean;
}

export function CertConfirmationModal({
  open,
  onClose,
  title,
  attestationText,
  confirmLabel = "Sign certification",
  onConfirm,
  pending = false,
}: CertConfirmationModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      description="Once signed, this entry is captured in the audit log and cannot be undone outside of an admin reset."
      size="md"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={pending}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => void onConfirm()} disabled={pending}>
            {pending ? "Signing…" : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-small text-onyx whitespace-pre-wrap m-0">
        {attestationText}
      </p>
    </Modal>
  );
}
